import { createRouter, createWebHistory } from 'vue-router';
import ProjectView from '@/views/ProjectView.vue';
import type { Component } from 'vue';

const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  routes: [
    {
      path: '/',
      component: ProjectView as Component,
    },
    {
      path: '/project',
      component: ProjectView as Component,
    },
    {
      path: '/lighting',
      component: ProjectView as Component,
    },
    {
      path: '/parts',
      component: ProjectView as Component,
    },
    {
      path: '/perspectives',
      component: ProjectView as Component,
    },
    {
      path: '/hotspots',
      component: ProjectView as Component,
    },
    {
      path: '/custom',
      component: ProjectView as Component,
    },
    {
      path: '/preview',
      component: ProjectView as Component,
    },
  ],
});

export default router;
